import {
  BiDashboardGrantPermission,
  BiDashboardPermission,
  BiDashboardVisibility,
  BiRevisionSource,
} from '@euler/model/bi/dashboard';
import dayjs from 'dayjs';

export const kBiVisibilityLabels: Record<BiDashboardVisibility, string> = {
  [BiDashboardVisibility.Private]: '仅自己和授权成员',
  [BiDashboardVisibility.Store]: '门店所有成员可查看',
};

export const kBiVisibilityTags: Record<BiDashboardVisibility, string> = {
  [BiDashboardVisibility.Private]: '私有',
  [BiDashboardVisibility.Store]: '门店可见',
};

export const kBiGrantLabels: Record<BiDashboardGrantPermission, string> = {
  [BiDashboardGrantPermission.View]: '可查看',
  [BiDashboardGrantPermission.Edit]: '可编辑',
};

export const kBiPermissionLabels: Record<BiDashboardPermission, string> = {
  [BiDashboardPermission.None]: '',
  [BiDashboardPermission.View]: '只读',
  [BiDashboardPermission.Edit]: '可编辑',
  [BiDashboardPermission.Manage]: '我的',
};

export const kBiRevisionSourceLabels: Record<BiRevisionSource, string> = {
  [BiRevisionSource.Manual]: '手动修改',
  [BiRevisionSource.Ai]: 'AI 修改',
  [BiRevisionSource.Undo]: '撤销',
  [BiRevisionSource.Add]: '添加图表',
  [BiRevisionSource.Create]: '创建看板',
};

/** `今天 14:05`, `10月3日 09:12`, or with the year when it is not this one. */
export function biTimeLabel(iso: string): string {
  const time = dayjs(iso);
  const now = dayjs();
  if (time.isSame(now, 'day')) return `今天 ${time.format('HH:mm')}`;
  if (time.isSame(now, 'year')) return time.format('M月D日 HH:mm');
  return time.format('YYYY年M月D日');
}
